import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['list', 'item'];
var baseStyleList = {
  borderRadius: '0.25rem'
};
var baseStyleItem = {
  textDecoration: 'none',
  fontWeight: 700,
  fontStyle: 'bold',
  letterSpacing: '0.2px',
  color: 'blue.600',
  _hover: {
    bg: 'blue.200'
  },
  _focus: {
    bg: 'blue.200'
  },
  _active: {
    bg: 'neutral.5'
  }
};
var baseStyleItemWithTab = {
  textDecoration: 'none',
  fontWeight: 700,
  fontStyle: 'bold',
  letterSpacing: '0.2px',
  color: 'blue.600',
  _hover: {
    color: 'blue.600',
    bg: "blue.50",
    border: 'none'
  },
  _focus: {
    bg: "#ffffff",
    border: 'none',
    textDecoration: 'none',
    fontWeight: 700,
    fontStyle: 'bold',
    letterSpacing: '0.2px',
    color: 'blue.600'
  },
  _active: {
    color: 'black',
    bg: 'blue.100'
  }
};
var baseStyle = {
  list: baseStyleList,
  item: baseStyleItem
};
var variants = {
  withTab: {
    item: baseStyleItemWithTab
  }
};
export var Menu = asMultiStyleConfig({
  parts,
  baseStyle,
  variants
});